/**
 * Utilitários de telefone (BR).
 * - onlyDigits: remove tudo que não for dígito
 * - formatTelefoneBR: máscara (11) 99999-9999 conforme digita
 * - toE164BR: normaliza para +55DDDNNNNNNNNN (compatível com HubSpot / E.164)
 */

export function onlyDigits(input: string | null | undefined): string {
  return (input ?? "").replace(/\D+/g, "");
}

/** Aplica máscara BR: (DD) NNNNN-NNNN (celular) ou (DD) NNNN-NNNN (fixo). */
export function formatTelefoneBR(v: string): string {
  const d = onlyDigits(v).slice(0, 11);
  if (d.length <= 2) return d.length ? `(${d}` : "";
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

/**
 * Normaliza telefone BR para E.164 (+55...). Inclui o 55 se o número já tiver
 * 10-11 dígitos (DDD + número). Se já vier com 12-13 dígitos começando em 55,
 * apenas prefixa "+". Retorna string vazia se não houver dígitos suficientes.
 */
export function toE164BR(v: string | null | undefined): string {
  const d = onlyDigits(v);
  if (!d) return "";
  if ((d.length === 12 || d.length === 13) && d.startsWith("55")) return `+${d}`;
  if (d.length === 10 || d.length === 11) return `+55${d}`;
  // Fallback: se o usuário digitou algo fora do padrão, ainda prefixa +55 para
  // manter compatibilidade com HubSpot (que exige código de país).
  return `+55${d}`;
}
